// extracted by mini-css-extract-plugin
export default {"cell_input":"CellInput_cell_input__c9nll"};